define([], ()=> {
    /** Default notion of the subtree validity. This validity is just tho validity of the node itself. */
    function defaultValidity(node) {
        return node.aspects.valid;
    }

    /** Notion of the validity for the array node. */
    function arrayValidity(node) {
        if (!node.aspects.valid) {
            return false;
        }
        const len = node.length;
        for (let i = 0; i < len; i++) {
            if (!node.getElement(i).aspects.subtreeValid) {
                return false;
            }
        }
        return true;
    }

    /** Returns a validity function for the dto. */
    function getDtoValidityFunction(info) {
        return (node)=> {
            if (!node.aspects.valid) {
                return false;
            }

            return info.properties.every((prop)=> {
                return !node[prop.jsProperty] || node[prop.jsProperty].aspects.subtreeValid;
            });
        };
    }

    /** Returns a function to extract validity from the metadata node. */
    function getValidityFn(metadata) {
        if (metadata.readOnly) {
            return () => true;
        }
        switch (metadata.valueType.kind) {
            case 'class' :
                const typeInfo = metadata.valueType.typeInfo;
                if (typeInfo.metaType.isDto) {
                    return getDtoValidityFunction(typeInfo);
                }
                return defaultValidity;
            case 'collection' :
                return arrayValidity;
            default:
                return defaultValidity;
        }
    }


    /** Aspect defining validity of the whole model subtree. */
    return {
        'getAspectProperties': (currentViewModelNode, currentMetadataNode/*, ancestorChain*/)=> {
            const accessor = getValidityFn(currentMetadataNode);

            return {
                'subtreeValid': {
                    'get': ()=> {
                        return accessor(currentViewModelNode);
                    }
                }
            };
        }
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/viewmodel/aspects/SubtreeValidity.js
 **/